import {
  LIST_SERVICE_REQUEST,
  LIST_SERVICE_SUCCESS,
  LIST_SERVICE_FAILURE,
  LIST_SERVICE_RESET,
  LIST_SERVICE_SUMARY_REQUEST,
  LIST_SERVICE_SUMARY_SUCCESS,
  LIST_SERVICE_SUMARY_FAILURE,
  LIST_SERVICE_SUMARY_RESET,
  CREATE_SERVICE_REQUEST,
  CREATE_SERVICE_SUCCESS,
  CREATE_SERVICE_FAILURE,
  DETAIL_SERVICE_REQUEST,
  DETAIL_SERVICE_SUCCESS,
  DETAIL_SERVICE_FAILURE,
  UPDATE_SERVICE_REQUEST,
  UPDATE_SERVICE_SUCCESS,
  UPDATE_SERVICE_FAILURE,
  EXPORT_SERVICE_REQUEST,
  EXPORT_SERVICE_SUCCESS,
  EXPORT_SERVICE_FAILURE,
  UPDATE_SERVICE_CHANGE_SERVICE_CLASSIFICATION_REQUEST,
  UPDATE_SERVICE_CHANGE_SERVICE_CLASSIFICATION_SUCCESS,
  UPDATE_SERVICE_CHANGE_SERVICE_CLASSIFICATION_FAILURE,
  DELETE_SERVICE_REQUEST,
  DELETE_SERVICE_SUCCESS,
  DELETE_SERVICE_FAILURE,
  LIST_SERVICE_ITEM_REQUEST,
  LIST_SERVICE_ITEM_SUCCESS,
  LIST_SERVICE_ITEM_FAILURE,
  ADD_ADDITIONAL_INFO_REQUEST,
  ADD_ADDITIONAL_INFO_SUCCESS,
  ADD_ADDITIONAL_INFO_FAILURE,
  DELETE_ADDITIONAL_INFO_REQUEST,
  DELETE_ADDITIONAL_INFO_SUCCESS,
  DELETE_ADDITIONAL_INFO_FAILURE,
  LIST_ADDITIONAL_INFO_SERVICE_REQUEST,
  LIST_ADDITIONAL_INFO_SERVICE_SUCCESS,
  LIST_ADDITIONAL_INFO_SERVICE_FAILURE,
  LIST_MEDICAL_INFO_SUMMARY_REQUEST,
  LIST_MEDICAL_INFO_SUMMARY_SUCCESS,
  LIST_MEDICAL_INFO_SUMMARY_FAILURE,
  SUMMARY_SERVICE_MEDINFO_SPECIMEN_REQUEST,
  SUMMARY_SERVICE_MEDINFO_SPECIMEN_SUCCESS,
  SUMMARY_SERVICE_MEDINFO_SPECIMEN_FAILURE,
  UPADATE_SERVICE_MEDINFO_SPECIMEN_REQUEST,
  UPADATE_SERVICE_MEDINFO_SPECIMEN_SUCCESS,
  UPADATE_SERVICE_MEDINFO_SPECIMEN_FAILURE,
  SERVICE_FORMAT_OPTION_SUMMARY_REQUEST,
  SERVICE_FORMAT_OPTION_SUMMARY_SUCCESS,
  SERVICE_FORMAT_OPTION_SUMMARY_FAILURE,
  UPDATE_FORMAT_OPTION_SERVICE_REQUEST,
  UPDATE_FORMAT_OPTION_SERVICE_SUCCESS,
  UPDATE_FORMAT_OPTION_SERVICE_FAILURE
} from '../../constants/services'

const initialState = {
  loading: false,
  loadingExport: false,
  loadingCreateAdditionalInfo: false,
  loadingDeleteAdditionalInfo: false,
  loadingDeleteAdditionalInfoAndMedicalInfo: false,
  loadingListAdditionalAndMedicalInfoInfo: false,
  loadingMedicalInfoSummary: false,
  loadingSummarySpecimen: false,
  loadingUpdateSpecimen: false,
  summarySpecimen: [],
  additionalInfoServices: [],
  services: [],
  service: {},
  serviceSummaries: [],
  medicalInfoSummary: [],
  serviceItems: [],
  error: '',
  pageable: {}
}

const serviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SERVICE_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        services: action.payload,
        pageable: action.pageable
      }
    case LIST_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        services: [],
        error: action.payload
      }
    case LIST_SERVICE_RESET:
      return {
        ...state,
        loading: false,
        services: [],
        error: ''
      }
    case LIST_SERVICE_SUMARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SERVICE_SUMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        serviceSummaries: action.payload
      }
    case LIST_SERVICE_SUMARY_FAILURE:
      return {
        ...state,
        loading: false,
        serviceSummaries: [],
        error: action.payload
      }
    case LIST_SERVICE_SUMARY_RESET:
      return {
        ...state,
        loading: false,
        serviceSummaries: [],
        error: ''
      }
    case CREATE_SERVICE_REQUEST:
      return {
        ...state,
        loading: true
      }
    case CREATE_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case CREATE_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        service: {},
        error: action.payload
      }
    case DETAIL_SERVICE_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_SERVICE_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        service: action.payload
      }
    case DETAIL_SERVICE_FAILURE:
      return {
        ...state,
        loadingDetail: false,
        service: {},
        error: action.payload
      }
    case UPDATE_SERVICE_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_SERVICE_SUCCESS:
      return {
        ...state,
        loadingUpdate: false
      }
    case UPDATE_SERVICE_FAILURE:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case EXPORT_SERVICE_REQUEST:
      return {
        ...state,
        loadingExport: true
      }
    case EXPORT_SERVICE_SUCCESS:
      return {
        ...state,
        loadingExport: false,
        error: null
      }
    case EXPORT_SERVICE_FAILURE:
      return {
        ...state,
        loadingExport: false,
        error: action.payload
      }
    case UPDATE_SERVICE_CHANGE_SERVICE_CLASSIFICATION_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_SERVICE_CHANGE_SERVICE_CLASSIFICATION_SUCCESS:
      return {
        ...state,
        loadingUpdate: false
      }
    case UPDATE_SERVICE_CHANGE_SERVICE_CLASSIFICATION_FAILURE:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_SERVICE_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_SERVICE_SUCCESS:
      const serviceId = action.payload
      const findIndex = state.services.findIndex(service => service.id === serviceId)
      state.services.splice(findIndex, 1)

      return {
        ...state,
        loadingDelete: false,
        services: state.services
      }
    case DELETE_SERVICE_FAILURE:
      return {
        ...state,
        loadingDelete: false,
        service: {},
        error: action.payload
      }
    case LIST_SERVICE_ITEM_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SERVICE_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        serviceItems: action.payload
      }
    case LIST_SERVICE_ITEM_FAILURE:
      return {
        ...state,
        loading: false,
        serviceItems: [],
        error: action.payload
      }
    case ADD_ADDITIONAL_INFO_REQUEST:
      return {
        ...state,
        loadingCreateAdditionalInfo: true
      }
    case ADD_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        loadingCreateAdditionalInfo: false,
        error: null
      }
    case ADD_ADDITIONAL_INFO_FAILURE:
      return {
        ...state,
        loadingCreateAdditionalInfo: false,
        error: action.payload
      }
    case DELETE_ADDITIONAL_INFO_REQUEST:
      return {
        ...state,
        loadingDeleteAdditionalInfoAndMedicalInfo: true
      }
    case DELETE_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        loadingDeleteAdditionalInfoAndMedicalInfo: false,
        error: null
      }
    case DELETE_ADDITIONAL_INFO_FAILURE:
      return {
        ...state,
        loadingDeleteAdditionalInfoAndMedicalInfo: false,
        error: action.payload
      }
    case LIST_ADDITIONAL_INFO_SERVICE_REQUEST:
      return {
        ...state,
        additionalInfoServices: [],
        loadingListAdditionalAndMedicalInfoInfo: true
      }
    case LIST_ADDITIONAL_INFO_SERVICE_SUCCESS:
      return {
        ...state,
        loadingListAdditionalAndMedicalInfoInfo: false,
        additionalInfoServices: action.payload,
        error: null
      }
    case LIST_ADDITIONAL_INFO_SERVICE_FAILURE:
      return {
        ...state,
        loadingListAdditionalAndMedicalInfoInfo: false,
        additionalInfoServices: [],
        error: action.payload
      }
    case LIST_MEDICAL_INFO_SUMMARY_REQUEST:
      return {
        ...state,
        loadingMedicalInfoSummary: true
      }
    case LIST_MEDICAL_INFO_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingMedicalInfoSummary: false,
        medicalInfoSummary: action.payload
      }
    case LIST_MEDICAL_INFO_SUMMARY_FAILURE:
      return {
        ...state,
        loadingMedicalInfoSummary: false,
        error: action.payload
      }
    case SUMMARY_SERVICE_MEDINFO_SPECIMEN_REQUEST:
      return {
        ...state,
        loadingSummarySpecimen: true
      }
    case SUMMARY_SERVICE_MEDINFO_SPECIMEN_SUCCESS:
      return {
        ...state,
        loadingSummarySpecimen: false,
        summarySpecimen: action.payload
      }
    case SUMMARY_SERVICE_MEDINFO_SPECIMEN_FAILURE:
      return {
        ...state,
        loadingSummarySpecimen: false,
        summarySpecimen: [],
        error: action.payload
      }
    case UPADATE_SERVICE_MEDINFO_SPECIMEN_REQUEST:
      return {
        ...state,
        loadingUpdateSpecimen: true
      }
    case UPADATE_SERVICE_MEDINFO_SPECIMEN_SUCCESS:
      return {
        ...state,
        loadingUpdateSpecimen: false,
        error: null
      }
    case UPADATE_SERVICE_MEDINFO_SPECIMEN_FAILURE:
      return {
        ...state,
        loadingUpdateSpecimen: false,
        error: action.payload
      }
    case SERVICE_FORMAT_OPTION_SUMMARY_REQUEST:
      return {
        ...state,
        loadingFormatOptionDetail: true
      }
    case SERVICE_FORMAT_OPTION_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingFormatOptionDetail: false,
        formatOptionDetail: action.payload
      }
    case SERVICE_FORMAT_OPTION_SUMMARY_FAILURE:
      return {
        ...state,
        loadingFormatOptionDetail: false,
        formatOptionDetail: [],
        error: action.payload
      }
    case UPDATE_FORMAT_OPTION_SERVICE_REQUEST:
      return {
        ...state,
        loadingUpdateFormatOption: true
      }
    case UPDATE_FORMAT_OPTION_SERVICE_SUCCESS:
      return {
        ...state,
        loadingUpdateFormatOption: false,
        error: null
      }
    case UPDATE_FORMAT_OPTION_SERVICE_FAILURE:
      return {
        ...state,
        loadingUpdateFormatOption: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default serviceReducer

